<template>
  <SessionModal :modal="settingsModalData" @setTab="setTab" @closeModal="toggleSettings"
    ><component :is="selectedTab.component"></component
  ></SessionModal>
</template>

<script>
import SessionModal from "../../../../../components/Modal/components/SessionModal";
import SettingsGeneral from "./SettingsGeneral";
import SettingsDevice from "./SettingsDevice";
import SettingsQuality from "./SettingsQuality";
import SettingsDesign from "./SettingsDesign";
import { updateSessionPreferences } from "../../SessionHelpers/session";

export default {
  name: "SessionSettings",
  components: {
    SessionModal,
    SettingsGeneral,
    SettingsDevice,
    SettingsQuality,
    SettingsDesign,
  },
  data() {
    return {
      tabs: [
        {
          name: "General",
          component: "SettingsGeneral",
          ID: 0,
        },
        {
          name: "Device",
          component: "SettingsDevice",
          ID: 1,
        },
        {
          name: "Quality",
          component: "SettingsQuality",
          ID: 2,
        },
        {
          name: "Design",
          component: "SettingsDesign",
          ID: 3,
        },
      ],
      selectedTab: null,
    };
  },
  created() {
    window.addEventListener("beforeunload", this.updateBeforeLeave); /* helps detect refresh */

    this.selectedTab = this.tabs[0];
  },
  beforeDestroy() {
    this.updateBeforeLeave();
  },
  beforeRouteLeave(to, from, next) {
    this.updateBeforeLeave(true, next);
  },
  methods: {
    /* Ensure 1) Refreshing 2) Route leave also perform update */
    async updateBeforeLeave(fromBeforeLeave = false, next = null) {
      window.removeEventListener("beforeunload", this.updateBeforeLeave);
      await this.updateDB();
      if (fromBeforeLeave && next !== null) {
        next();
      }
    },
    async updateDB() {
      await updateSessionPreferences();
    },
    toggleSettings() {
      this.$store.dispatch("toolbar/toggleToolbar", "settings");
    },
    setTab(newTab) {
      this.selectedTab = newTab;
    },
  },
  computed: {
    settingsModalData() {
      return {
        title: "Session settings",
        tabs: this.tabs,
        selectedTab: this.selectedTab,
      };
    },
  },
};
</script>

<style>
@import "../../../../../components/Modal/styles/SessionModal.css";
</style>
